import React from "react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Edit, Trash2, StickyNote } from "lucide-react";

export const MemberReportTable = ({ user, paginatedMembers, onNote, onEdit, onDelete }) => {
  const canAct = user?.role === "superadmin" || user?.role === "supervisor";

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#0f0f10] border-red-900/30 hover:bg-[#0f0f10]">
            <TableHead className="text-red-400 font-semibold">Username</TableHead>
            <TableHead className="text-red-400 font-semibold">Marketing</TableHead>
            <TableHead className="text-red-400 font-semibold">Website</TableHead>
            <TableHead className="text-red-400 font-semibold">Kode DB</TableHead>
            <TableHead className="text-red-400 font-semibold">No. HP</TableHead>
            <TableHead className="text-red-400 font-semibold">Status</TableHead>
            <TableHead className="text-red-400 font-semibold">Nominal Depo</TableHead>
            <TableHead className="text-red-400 font-semibold">Follow Up</TableHead>
            <TableHead className="text-red-400 font-semibold">Submitted By</TableHead>
            <TableHead className="text-red-400 font-semibold">Tanggal Submit</TableHead>
            {canAct && <TableHead className="text-red-400 font-semibold text-center">Aksi</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {paginatedMembers.map((member) => (
            <TableRow key={member.id} className="border-red-900/20 hover:bg-[#0f0f10]/50">
              <TableCell className="font-medium text-white">{member.username}</TableCell>
              <TableCell className="text-gray-300">{member.marketing_name}</TableCell>
              <TableCell className="text-gray-300">{member.website}</TableCell>
              <TableCell className="text-gray-300">{member.kode_db}</TableCell>
              <TableCell className="text-gray-300">{member.phone}</TableCell>
              <TableCell>
                {member.member_type === "ndp" ? (
                  <span className="px-2 py-1 rounded text-xs font-semibold bg-green-900/30 text-green-400 border border-green-700/50">
                    NDP
                  </span>
                ) : (
                  <span className="px-2 py-1 rounded text-xs font-semibold bg-yellow-900/30 text-yellow-400 border border-yellow-700/50">
                    REGIS
                  </span>
                )}
              </TableCell>
              <TableCell className="text-green-400 font-semibold">
                {member.member_type === "ndp" && member.nominal_depo
                  ? "Rp " + member.nominal_depo.toLocaleString("id-ID")
                  : "-"}
              </TableCell>
              <TableCell className="text-blue-400">{member.closed_by || "-"}</TableCell>
              <TableCell className="text-purple-400">{member.submitted_by || "-"}</TableCell>
              <TableCell className="text-gray-300 text-xs">
                {member.submitted_at ? new Date(member.submitted_at).toLocaleDateString("id-ID") : "-"}
              </TableCell>
              {canAct && (
                <TableCell className="text-center">
                  <div className="flex gap-1 justify-center">
                    <Button
                      onClick={() => onNote(member)}
                      variant="ghost"
                      size="sm"
                      className="text-purple-400 hover:text-purple-300 hover:bg-purple-900/20"
                      title="Tambah catatan"
                      data-testid={`note-btn-${member.id}`}
                    >
                      <StickyNote size={16} />
                    </Button>
                    {user?.role === "superadmin" && (
                      <>
                        <Button
                          onClick={() => onEdit(member)}
                          variant="ghost"
                          size="sm"
                          className="text-blue-400 hover:text-blue-300 hover:bg-blue-900/20"
                          title="Edit member"
                          data-testid={`edit-member-${member.id}`}
                        >
                          <Edit size={16} />
                        </Button>
                        <Button
                          onClick={() => onDelete(member.id, member.username)}
                          variant="ghost"
                          size="sm"
                          className="text-red-400 hover:text-red-300 hover:bg-red-900/20"
                          title="Hapus member"
                          data-testid={`delete-member-${member.id}`}
                        >
                          <Trash2 size={16} />
                        </Button>
                      </>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default MemberReportTable;
